import React from 'react';
import { useStyletron } from 'baseui';
import type { KIND as TagKind } from 'baseui/tag';
import { Tag } from 'baseui/tag';
const tagOverrides = {
  Root: {
    style: ({
      $theme
    }) => ({
      margin: 0,
      padding: `${$theme.sizing.scale100} ${$theme.sizing.scale200}`
    })
  },
  Text: {
    style: ({
      $theme
    }) => ({
      ...$theme.typography.LabelXSmall,
      maxWidth: '100%'
    })
  },
  StartEnhancerContainer: {
    style: ({
      $theme
    }) => ({
      paddingRight: $theme.sizing.scale100
    })
  }
};
const truncateTagOverrides = {
  ...tagOverrides,
  Text: {
    style: ({
      $theme
    }) => ({
      ...tagOverrides.Text.style({
        $theme
      }),
      maxWidth: 'none'
    })
  }
};
type StatusListProps = {
  list: {
    label: string;
    kind: (typeof TagKind)[keyof typeof TagKind];
    startEnhancer?: React.ReactNode;
    truncate?: boolean;
  }[];
};
export const StatusList = ({
  list
}: StatusListProps) => {
  const [css, theme] = useStyletron();
  if (list.length === 0) {
    return null;
  }
  return <div className={css({
    display: 'flex',
    gap: '8px',
    flexWrap: 'wrap',
    paddingBottom: theme.sizing.scale600
  })}>
      {list.map(tag => {
      const shouldTruncate = tag.hasOwnProperty('truncate') && tag.truncate === false;
      return <Tag key={tag.label} kind={tag.kind} startEnhancer={() => <>{tag.startEnhancer}</>} overrides={shouldTruncate ? truncateTagOverrides : tagOverrides} closeable={false}>
            {tag.label}
          </Tag>;
    })}
    </div>;
};